import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { RemoveItemIcon } from '@/assets/icons/RemoveItemIcon';
import { mergeSx } from '@/utils/mergeSx';

import { removeFormFieldStyles as sx } from './RemoveFormFieldButton.styles';

type Props = {
	onClick: () => void;
	customSx?: SxProps<Theme>;
	type?: 'button' | 'icon';
};

export const RemoveFormFieldButton = ({
	type = 'icon',
	onClick,
	customSx
}: Props) => {
	const { t } = useTranslation();

	if (type === 'button') {
		return (
			<Button
				sx={mergeSx(sx.button, customSx)}
				variant='text'
				onClick={onClick}
				aria-label='Remove field'
				size='small'
			>
				{t('Remove')}
			</Button>
		);
	}

	return (
		<IconButton
			disableRipple
			size='small'
			aria-label='Remove field'
			onClick={onClick}
			sx={mergeSx(sx.remover, customSx)}
		>
			<RemoveItemIcon sx={sx.icon} />
		</IconButton>
	);
};
